import { useEffect } from "react";
import { EDITION_BT_LINK } from "@features/banner/Edition/utils/constants";
import { useCountry } from "@hooks/useCountry";
import { useIsGooglebot } from "@hooks/useIsGooglebot";
import { IS_PLAYWRIGHT } from "@util/constant";
import Cookies from "js-cookie";

/** Hook to use to redirect BTG Homepage to BTSG homepage. */
export const useBTGHomepageRedirect = () => {
  const { isSGUser } = useCountry();
  const isGooglebot = useIsGooglebot();

  const isGlobalUser = !isSGUser;

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (isGooglebot) return;
    if (IS_PLAYWRIGHT) return;

    const userPreferredVersion = Cookies.get("preferred_region");

    if (userPreferredVersion === "NONSG") return;
    if (isGlobalUser && typeof userPreferredVersion === "undefined") return;

    const linkParams = new URLSearchParams({
      ref: "btg-home-redirect",
    });
    const params = `?${linkParams?.toString()}`;

    const redirectUrl = `${EDITION_BT_LINK}${params}`;
    window.location.href = redirectUrl;
  }, [isGooglebot, isGlobalUser]);
};
